import { render, staticRenderFns } from "./UserSupportView.vue?vue&type=template&id=0849e000"
import script from "./UserSupportView.vue?vue&type=script&lang=js"
export * from "./UserSupportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports